export default "<div class=\"icon\"></div> {{ message | translate: options }}\n"